'use client';

import { LazyLottie } from './LazyLottie';
import { IAnimationProps } from './types';

export function ErrorNoWifiAnimation(props: IAnimationProps) {
  const loadAnimation = () => import('./raw-json/no-wifi.json');

  return (
    <LazyLottie
      {...props}
      getAnimationData={loadAnimation}
      id="ErrorNoWifiAnimation"
    />
  );
}
